<template lang="pug">
  div.heatmap.settings-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
                name="min"
                label="Минимальное значение (чел.)"
                :model="fields"
                required=true
                tabView="tab1"
              )

              e-form-group(
                name="max"
                label="Максимальное значение (чел.)"
                :model="fields"
                tabView="tab1"
              )

              e-form-group(
                name="color"
                label="Цвет"
                :model="fields"
                tabView="tab1"
                :required="true"
              )
                slot
                  div.color-chooser
                    div(
                      @click.stop.prevent="showColorPallet=!showColorPallet"
                      :style="{'background-color': fields.color}"
                    ).color-preview
                    button(
                      @click.stop.prevent="showColorPallet=!showColorPallet"
                    ).actions-filter-panel__button.color-select-btn {{showColorPallet ? 'Скрыть палитру' : 'Выбор цвета'}}
                  div(
                    @click.stop.prevent=""
                  ).color-pallet
                    chrome(
                      v-if="showColorPallet"
                      v-model="fields.colorObject"
                      @input="updateColor"
                      :disableAlpha="true"
                    )
</template>
<script>
  import { map }       from '../../api/api-endpoints.js'
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import { Chrome }    from 'vue-color'

  const COLOR_FORMAT = 'hex'
  const HEATMAP_TYPE = 'population'

  export default {
    mixins:     [formBaseMixin],
    components: { Chrome },
    data() {
      return {
        showTkoOperatorSelectTable: false,
        showColorPallet:            false,
        fields:                     {
          colorObject: null,
          min:         0,
          max:         '',
          color:       ''
        }
      }
    },
    methods: {
      getUpdateOrCreateUrl() {
        if (!this.$route.params.id) {
          return map.heatMapSettingsCreate(HEATMAP_TYPE)
        }
        return map.heatMapSettingsItem(+this.$route.params.id)
      },
      getItemEndpoint(route) {
        if (!route.params.id) {
          return null
        }
        return map.heatMapSettingsItem(+route.params.id)
      },
      initFieldsAfterLoad() {
        if (this.item) {
          this.fields             = Object.assign({}, this.item)
          this.fields.colorObject = {
            [COLOR_FORMAT]: this.item.color
          }
        } else {
          this.fields.colorObject = {
            [COLOR_FORMAT]: ''
          }
        }
      },
      updateColor(colorObj) {
        this.$set(this.fields, 'color', colorObj[COLOR_FORMAT])
      }
    }
  }
</script>
